import React, { useRef, useState } from "react";
import { FileIcon, defaultStyles } from "react-file-icon";
import { StyledFileList } from "./styles";
import { ConfirmationModal } from "./ConfirmationModal";
import { translate } from "../../utils/translations/translate";
import DeleteIcon from "@mui/icons-material/Delete";
import { FETCH_FILE_DATA } from "../../utils/services/constants";
import { getAuthHeaders } from "../../utils/services/auth";
import { useFetch } from "../../utils/hooks/useFetch";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";

export const FileInfo = ({ isReadMode, files, onFileRemove = () => {} }) => {
  const itemToBeDeleted = useRef(null);
  const { performAction } = useFetch();
  const prefixes = [
    "Attachments_",
    "POMSA_",
    "PO_WO_SOW_",
    "VendorLetter_",
    "COI_",
    "OtherAttachments_",
  ];
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleClose = () => {
    setShowDeleteModal(false);
    itemToBeDeleted.current = null;
  };
  const handleConfirm = () => {
    onFileRemove(itemToBeDeleted.current);
    handleClose();
  };

  const getFileName = (fileName) => {
    const matched = prefixes.find((prefix) => fileName.includes(prefix));
    const result = matched ? fileName.split(matched)[1] : fileName;
    return result;
  };

  const downloadFile = async (fileName) => {
    try {
      const response = await performAction(
        `${FETCH_FILE_DATA}?FileName=${fileName}`,
        {
          method: "GET",
          headers: getAuthHeaders(),
        }
      );

      const blob = await response.blob();
      const finalFileName = fileName.split("/").pop();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = finalFileName;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error fetching file:", error);
    }
  };
  const handleOpenFile = (file) => {
    const imageExtensions = [
      "jpg",
      "jpeg",
      "png",
      "gif",
      "bmp",
      "webp",
      "tiff",
      "svg",
      "pdf",
      "csv",
      "txt",
    ];
    if (imageExtensions.includes(file.extension.toLowerCase())) {
      window.open(file.accessUrl, "_blank");
    } else {
      const fileUrl = encodeURIComponent(file.accessUrl);
      window.open(
        `https://view.officeapps.live.com/op/view.aspx?src=${fileUrl}`,
        "_blank"
      );
    }
  };
  return (
    <StyledFileList className="tma_file_info_list" type="none">
      {files.map((file, idx) => {
        const { fileName, accessUrl, extension } = file;
        return (
          <li key={idx} className="tma_file_item">
            <FileIcon
              extension={extension}
              {...(defaultStyles[extension] || defaultStyles.default)}
            />
            {/* <a href={accessUrl} rel="noreferrer" target="_blank">
              {getFileName(fileName)}
            </a> */}
            <div className="file_download" onClick={() => handleOpenFile(file)}>
              {getFileName(fileName)}
            </div>{" "}
            <div style={{ display: "flex" }}>
              {true ? (
                <div
                  className="VisibilityIcon"
                  onClick={() => downloadFile(file?.orignalFile)}
                >
                  <a>
                    <DownloadIcon
                      style={{
                        fontSize: "20px",
                        color: "#1b73d8",
                        display: "block",
                        cursor: "pointer",
                      }}
                    />
                  </a>
                </div>
              ) : null}
              &nbsp;
              {!isReadMode && fileName && (
                <button
                  type="button"
                  onClick={() => {
                    itemToBeDeleted.current = idx;
                    setShowDeleteModal(true);
                  }}
                  className="tma_file_remove"
                >
                  <DeleteIcon />
                </button>
              )}
            </div>
          </li>
        );
      })}
      {showDeleteModal && (
        <ConfirmationModal
          title={translate("labels.deleteAttachment")}
          infoText={translate("labels.deleteAttachmentInfo")}
          onClose={handleClose}
          onConfirm={handleConfirm}
        />
      )}
    </StyledFileList>
  );
};
